import React from 'react';
import ModuloTemplate from '../Elements/ModuloTemplate';

const bnrimg = require('../../images/pic3.jpg');
const productImg = require('../../images/reportes.png');

const ReportsModule = () => (
    <ModuloTemplate
        moduleKey="reportes"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default ReportsModule;
